import { render, staticRenderFns } from "./DivisionReceiverPage.vue?vue&type=template&id=6b5c7ae3"
import script from "./DivisionReceiverPage.vue?vue&type=script&lang=js"
export * from "./DivisionReceiverPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b5c7ae3')) {
      api.createRecord('6b5c7ae3', component.options)
    } else {
      api.reload('6b5c7ae3', component.options)
    }
    module.hot.accept("./DivisionReceiverPage.vue?vue&type=template&id=6b5c7ae3", function () {
      api.rerender('6b5c7ae3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/division/receiver/DivisionReceiverPage.vue"
export default component.exports